import { Component, ComponentFactoryResolver, OnInit, ViewChild } from '@angular/core';
import { DashboardMessagesService } from '@services/dashboard-messages/dashboard-messages.service';
import { Models } from '@ibexfusion/models';
import { FormDirective } from '../../../directives/form/form.directive';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { FormComponent } from '../../../components/default-form/form.component';
import { DefaultFormComponent } from '../../../components/default-form/default-form.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-dashboard-message-edit',
    templateUrl: './dashboard-message-edit.component.html',
    styleUrls: ['./dashboard-message-edit.component.scss'],
    providers: [DashboardMessagesService],
    standalone: false
})
export class DashboardMessageEditComponent implements OnInit {
  isLoading = true;
  pageActions: PageAction[];

  messageId: string = null;
  message: Models.DashboardMessage;

  selectedTabIndex = 0;

  constructor(private dashboardMessageService: DashboardMessagesService, private activatedRoute: ActivatedRoute, private router: Router, private snackbar: SnackbarService) {
  }

  ngOnInit() {
    this.isLoading = true;
    this.messageId = this.activatedRoute.snapshot.params['id'];
    this.messageId ? this.fetchMessage() : this.createMessage();
  }

  async fetchMessage() {
    this.message = await this.dashboardMessageService.get(this.messageId);
    if (this.message.translations[0].lang === 'en') {
      this.message.translations.reverse();
    }
    this.isLoading = false;
  }

  createMessage() {
    this.message = <Models.DashboardMessage>Models.ModelFactory.createModelInstanceByName('DashboardMessage');
    const messageEN = <Models.DashboardMessageTranslation>Models.ModelFactory.createModelInstanceByName('DashboardMessageTranslation');
    const messageDE = <Models.DashboardMessageTranslation>Models.ModelFactory.createModelInstanceByName('DashboardMessageTranslation');
    messageEN.lang = 'en';
    messageDE.lang = 'de';
    this.message.translations = [messageDE, messageEN];
    this.isLoading = false;
  }

  async save() {
    this.message.title = this.message?.translations?.[0]?.title;
    this.isLoading = true;
    this.message.translations.forEach((translation, i) => {
      this.message.translations[i].message = this.cleanUpQuillContent(translation.message);
    });
    if (!this.messageId) {
      const result = await this.dashboardMessageService.create(this.message);
      await this.router.navigate(['dashboard-messages', result._id]);
    } else {
      await this.dashboardMessageService.update(this.messageId, this.message)
    }
    this.snackbar.success('saved');
  }

  quillChanged(event, translation) {
    translation.message = event;
  }

  cleanUpQuillContent(content) {
    if (!content) return content;
    while (content.match(/<p><br><\/p>$/gm)) {
      content = content.replace(/<p><br><\/p>$/gm, '');
    }
    return content;
  }

  public tabChange(event) {
    this.selectedTabIndex = event.index;
  }
}
